import DeviceTypeLabel from './DeviceTypeLabel';

export default DeviceTypeLabel;
